import Routing from "./Routing.provider";

export default Routing;
